export const StockStatus = {
    InStock: 'InStock',
    OutOfStock: 'OutOfStock',
    DisplayOnly: 'DisplayOnly',
};
